import '@onereach/styles/main-v3.css';

import { setupPermissions, type SetupPermissionsOptions } from '@onereach/permissions-ui';
import { createApp } from 'vue';
import type { Plugin } from 'vue';

import config from '@/config';
import { useAuthStore } from '@/stores/auth/auth';
import createPinia from '@/stores/main';

import App from './app.vue';
import i18n from './i18n/i18n';
import router from './router/router';
import SentryApi from './sentry';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(i18n);

app.use(setupPermissions({
  permissionsUrl: config.PERMISSIONS_API_URL,
  token: () => useAuthStore().reactiveToken as string,
  userRole: () => useAuthStore().role,
  serviceName: '*',
  i18n,
} as unknown as SetupPermissionsOptions) as unknown as Plugin);

app.use(router);

SentryApi.init(app, router);

app.mount('#app');
